/*
 * @Autor: Nehc
 * @Date: 2020-12-11 14:53:05
 * @LastEditors: Nehc
 * @LastEditTime: 2020-12-11 14:56:41
 */
import Form from './form.vue';

export default Form;
